import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/cover.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-57e8ba16"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "pic"
};
var _hoisted_2 = ["title"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "cover"
  }, null, -1);
});

var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "title2"
};
var _hoisted_6 = {
  class: "title3"
};
var _hoisted_7 = {
  class: "title4 title4-4"
};
export default {
  props: {
    scale: {
      type: String,
      default: '',
      required: true
    },
    title: {
      type: String,
      default: '',
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "cover-container",
        style: _normalizeStyle(props.scale),
        title: __props.title
      }, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(__props.title), 1)])])])], 12, _hoisted_2)]);
    };
  }
};